module.exports = __webpack_public_path__ + "img/upload_zodiac_1.26cfff0d.webp";